<template>
  <div class="stages">
    <ContentSectionStableCoinExplanationStageCard :card="stages[0]" />
    <ContentSectionStableCoinExplanationStagePath
      beforeStage="1"
      :isActive="!Number(settings?.token_sale_stage)"
    />
    <ContentSectionStableCoinExplanationStageCard :card="stages[1]" />
    <ContentSectionStableCoinExplanationStagePath
      beforeStage="2"
      :isActive="Number(settings?.token_sale_stage) === 1"
    />
    <ContentSectionStableCoinExplanationStageCard :card="stages[2]" />
    <ContentSectionStableCoinExplanationStagePath
      beforeStage="3"
      :isActive="Number(settings?.token_sale_stage) === 2"
    />
    <ContentSectionStableCoinExplanationStageCard
      is-infinite-boost
      :card="stages[3]"
    />
  </div>
</template>

<script>
export default {
  name: 'ContentSectionStableCoinExplanationStages',
  data: () => ({
    settings: useState(appStateConstants.SETTINGS)
  }),
  computed: {
    stages() {
      return [
        {
          id: 1,
          name: getContent('section_stablecoin_explanation.stage_0_name'),
          comment: null,
          boost: null,
          isStarted: true,
          isFinished: !!Number(this.settings?.token_sale_stage)
        },
        {
          id: 2,
          name: getContent('section_stablecoin_explanation.stage_1_name'),
          comment: getContent('section_stablecoin_explanation.stage_1_comment'),
          boost: getContent('section_stablecoin_explanation.stage_1_boost'),
          isStarted: !!Number(this.settings?.token_sale_stage),
          isFinished: Number(this.settings?.token_sale_stage) > 1
        },
        {
          id: 3,
          name: getContent('section_stablecoin_explanation.stage_2_name'),
          comment: getContent('section_stablecoin_explanation.stage_2_comment'),
          boost: getContent('section_stablecoin_explanation.stage_2_boost'),
          isStarted: Number(this.settings?.token_sale_stage) > 1,
          isFinished: Number(this.settings?.token_sale_stage) > 2
        },
        {
          id: 4,
          name: getContent('section_stablecoin_explanation.stage_3_name'),
          comment: getContent('section_stablecoin_explanation.stage_3_comment'),
          isStarted: Number(this.settings?.token_sale_stage) > 2,
          isFinished: false
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.stages {
  gap: 10px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
</style>
